import React from 'react';
import ReactDropzone, { DropzoneProps as ReactDropzoneProps } from 'react-dropzone';

import { createStyles, Theme, WithStyles, withStyles } from '@material-ui/core';
import classnames from 'classnames';

const styles = ({
  spacing: { unit },
  custom: {
    palette: { colorSupportSlate },
  },
}: Theme) =>
  createStyles({
    root: {
      borderColor: colorSupportSlate,
      borderStyle: 'dashed',
      borderWidth: 3,
      marginBottom: unit * 3,
      padding: `${unit}px ${unit}px`,
      width: '100%',
    },
  });

export interface DropzoneProps extends Omit<ReactDropzoneProps, 'classes'>, WithStyles<typeof styles> {}

const DropzoneComponent: React.FC<DropzoneProps> = ({ classes, className, ...rest }) => (
  <ReactDropzone className={classnames(classes.root, className)} {...rest} />
);

export const Dropzone = withStyles(styles)(DropzoneComponent);
